import React, { createContext, useContext, useState } from "react";

interface WordContextProps {
  shouldIgnoreClicks: boolean;
  setShouldIgnoreClicks: (should: boolean) => void;
}

const WordContext = createContext<WordContextProps>({
  shouldIgnoreClicks: false,
  setShouldIgnoreClicks: () => {},
});

export const WordContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [shouldIgnoreClicks, setShouldIgnoreClicks] = useState(false);

  return (
    <WordContext.Provider
      value={{
        shouldIgnoreClicks,
        setShouldIgnoreClicks,
      }}
    >
      {children}
    </WordContext.Provider>
  );
};

export const useWordContext = (): WordContextProps => {
  const context = useContext(WordContext);
  if (!context) {
    throw new Error(
      "useWordContext must be used within an WordContextProvider"
    );
  }
  return context;
};
